import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiListItem(theme: Theme): Components['MuiListItem'] {
  return {
    styleOverrides: {
      root: {
        textAlign: 'start',
      },
      dense: {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
      },
    },
  };
}
